<template>
  <v-dialog
    v-model="dialog"
    persistent
    content-class="elevation-0"
  >
    <v-card
      outlined
      color="transparent"
    >
      <v-card-text class="text-xs-center">
        <v-progress-circular
          :size="70"
          indeterminate
          color="white"
          class="mb-0"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    dialog() {
      return this.$store.state.aiInspectionLoading;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/InspectionLoading.vue